import * as yup from 'yup';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';

export const loanAmountSchema = (transactionType: eTransactionCategory) => {
  return transactionType === eTransactionCategory.Refinance
    ? yup.object().shape({
        loanAmount: yup.number().required().nullable(),
      })
    : yup.object().shape({
        loanAmount: yup.number().nullable(),
      });
};
